'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const mapOrderItemToCartItem = _ref => {
  var _orderItem$price, _orderItem$price2;
  let {
    orderItem,
    quantity,
    selectedReason,
    customerComments
  } = _ref;
  return {
    // todo: Need to change the types in react sdk to match incoming and outgoing item types
    name: orderItem.name || '',
    price: {
      currency: ((_orderItem$price = orderItem.price) === null || _orderItem$price === void 0 ? void 0 : _orderItem$price.currency) || 'USD',
      value: ((_orderItem$price2 = orderItem.price) === null || _orderItem$price2 === void 0 ? void 0 : _orderItem$price2.value) || 0
    },
    quantity: quantity || 1,
    reason: {
      id: selectedReason.id
    },
    customerComments,
    sku: orderItem.sku,
    imageUrl: orderItem.imageUrl,
    itemId: orderItem.itemId,
    categories: orderItem.categories
  };
};

exports["default"] = mapOrderItemToCartItem;
